module.exports = __webpack_public_path__ + "img/default-profile-image.04919d49.svg";